import { Location } from '../types/location';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export interface ImportLocationResult {
  success: boolean;
  message: string;
  data?: {
    imported: number;
    errors: Array<{
      row: number;
      field?: string;
      message: string;
      data?: any;
    }>;
    warnings: Array<{
      row: number;
      message: string;
      data?: any;
    }>;
  };
}

export const LocationService = {
  /**
   * Get all locations (filtered by user permissions)
   * - Super admins see all locations
   * - Organization admins see only their organization's locations
   */
  getAllLocations: async (): Promise<Location[]> => {
    try {
      const response = await fetch(`${API_URL}/locations`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch locations: ${response.status}`);
      }

      const data = await response.json();
      if (data.success) {
        return data.data;
      } else {
        throw new Error(data.message || 'Failed to fetch locations');
      }
    } catch (error) {
      console.error('Failed to fetch locations:', error);
      throw error;
    }
  },

  /**
   * Import locations from CSV file
   */
  importLocations: async (csvFile: File, organizationId?: number): Promise<ImportLocationResult> => {
    try {
      const formData = new FormData();
      formData.append('csvFile', csvFile);
      
      if (organizationId) {
        formData.append('organization_id', organizationId.toString());
      }

      const response = await fetch(`${API_URL}/locations/import`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || `HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;

    } catch (error) {
      console.error('Failed to import locations:', error);
      throw error;
    }
  }
};
















